import React from 'react';
import { node } from 'prop-types';

const StatisticsTableItem = props => <td>{props.value}</td>;

StatisticsTableItem.propTypes = {
  value: node,
};

export default StatisticsTableItem;
